export const getHome = (navigate) => {
  if (import.meta.env.MODE === 'development') {
    navigate('/login');
  } else {
    window.location.replace('/');
  }
};
